document.addEventListener("DOMContentLoaded", function () {
  const readMoreButtons = document.querySelectorAll(".step__read-more");

  readMoreButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const wrapper = this.closest(".step__text-wrapper");
      const text = wrapper.querySelector(".step__text");
      const isExpanded = this.getAttribute("aria-expanded") === "true";

      if (isExpanded) {
        text.classList.remove("step__text--expanded");
        this.setAttribute("aria-expanded", "false");
      } else {
        text.classList.add("step__text--expanded");
        this.setAttribute("aria-expanded", "true");
      }
    });
  });
});
